export default __webpack_public_path__ + "84a57ec0cce17db57b0c490a843c1023.svg";